const API_KEY = 'bc30c3cfc81935a26e8fa51ad2166ffe';
export default API_KEY;
